import { useState, useEffect } from "react";
import { chatService } from "services/chatService";
import { useParams } from "react-router-dom";

export default function useChatAndUserData() {
  const { chatId } = useParams();
  const [chatData, setChatData] = useState(null);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchChatAndUserData = async () => {
      setLoading(true);
      try {
        const chatResponse = await chatService.getChatById(chatId);
        if (chatResponse && chatResponse.error) {
          throw new Error(chatResponse.error);
        }
        setChatData(chatResponse);
      } catch (error) {
        console.error("Error fetching chat and user data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchChatAndUserData();
  }, []);

  return { chatData, loading };
}
